import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';

import { mainModule } from './main';
import { State } from './state';
import { adminModule } from './admin';
import { consumersModule } from './consumers';
import { scansModule } from './scans';
import { mapsModule } from './maps';
import { targetsModule } from './targets';
import { productsModule } from './products';
import { appsModule } from './apps';
import { filterModule } from './filter';

Vue.use(Vuex);

const storeOptions: StoreOptions<State> = {
  modules: {
    main: mainModule,
    admin: adminModule,
    consumers: consumersModule,
    scans: scansModule,
    maps: mapsModule,
    targets: targetsModule,
    products: productsModule,
    apps: appsModule,
    filter: filterModule,
  },
};

export const store = new Vuex.Store<State>(storeOptions);

export default store;
